import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { Form, Formik } from 'formik'
import { api } from '~/services/api'

import { Container } from './styles'

import Card from '~/components/Card'
import { Textarea, Button } from '~/components/Form'
import Spinner from '~/components/Spinner'
import RatingStarts from '~/components/RatingStarts'

import syndi from '~/assets/images/syndi.png'

export default function () {
    const { token } = useParams()

    const [atendimento, setAtendimento] = useState(null)
    const [alreadyRated, setAlreadyRated] = useState(false)
    const [avaliado, setAvaliado] = useState(false)

    async function loadAtendimento() {
        const response = await api.get(`atendimento/token/${token}`)

        if(response.avaliacao) {
            setAlreadyRated(true)
        }

        setAtendimento(response)
    }

    async function handleSubmit(values) {
        try {
            const [rating] = [...document.querySelectorAll('input[name=rating]')]
                .map(r => ({
                    id: r.id,
                    value: r.checked
                }))
                .filter(r => r.value)

            await api.post(`atendimento/token/${token}`, {
                ...values,
                rating: Number(rating.id.split('-')[1])
            })

            toast.success('Obrigado pelo seu feedback! Conte conosco!')

            setAvaliado(true)
        } catch(e) {
            toast.error(e.msg)
        }
    }

    useEffect(() => {
        if(token) {
            loadAtendimento()
        }
    }, [token])

    return (
        <Container>
            <main>
                <Card>
                    <h1>Atendimento SINDMEPA</h1>

                    <img src={syndi} alt="Syndi" />

                    {!atendimento ? (
                        <Spinner />
                    ) : alreadyRated ? (
                        <div className="balloon">
                            <p>Este atendimento já foi avaliado. Obrigada!</p>
                        </div>
                    ) : avaliado ? (
                        <div className="balloon">
                            <p>O SINDMEPA agradece sua avaliação!</p>
                        </div>
                    ) : (
                        <>
                            <div className="balloon">
                                {atendimento ? (
                                    <>
                                        <p>{`Olá, Dr${atendimento?.associado.pessoa.sexo === 'F' ? 'ª' : ''} ${atendimento?.associado.pessoa.nome}, eu gostaria de contar com sua opinião sobre o nosso atendimento.`}</p>
                                        <p>Por favor, qualifique o atendimento de 1 a 5 estrelas.</p>
                                    </>
                                ) : (
                                    <p>Aguarde...</p>
                                )}
                            </div>

                            {atendimento && (
                                <Formik
                                    initialValues={{ observacao: '' }}
                                    onSubmit={handleSubmit}
                                >
                                    {({ isSubmitting }) => (
                                        <Form>
                                            <RatingStarts />

                                            <Textarea 
                                                name="observacao"
                                                label="Digite seu feedback"
                                            />

                                            <Button type="submit" className="transparent" loading={isSubmitting}>
                                                Enviar feedback
                                            </Button>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </>
                    )}
                </Card>
            </main>
        </Container>
    )
}
